import { classNames } from "primereact/utils";

const FormField = ({ label, htmlFor, hint, error, required, children, className }) => (
  <div className={classNames("admin-field", className, { "admin-field--error": !!error })}>
    {label && (
      <label className="admin-field__label" htmlFor={htmlFor}>
        {label}
        {required && <span className="admin-field__required" aria-hidden="true"> *</span>}
      </label>
    )}
    {children}
    {error ? (
      <span className="admin-field__error" role="alert">
        {error}
      </span>
    ) : (
      hint && <span className="admin-field__hint">{hint}</span>
    )}
  </div>
);

export default FormField;
